import React, { useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';

import ToMainMenuButton from '@ts-core/components/ToMainMenuButton';
import { useCourseStats } from '@ts-core/modules/courses/hooks';

import CourseStatsTable from '../../components/CourseStatsTable';
import { CourseStats, CourseSubjectWithStats } from '../../types/stats';
import { courseStatsFragment } from '../../graphql/fragments';

const CourseStatsPage = () => {
  const history = useHistory();
  const { courseId } = useParams<{ courseId: string }>();
  const intl = useIntl();

  const { loading, error, stats, onRefetchStats } = useCourseStats<CourseStats>({ courseId, fragment: courseStatsFragment });

  const handleSelectSubject = useCallback(
    (subject: CourseSubjectWithStats) => {
      history.push(`/${courseId}/stats/subjects/${subject.id}`);
    },
    [history, courseId]
  );
  return (
    <>
      <ToMainMenuButton title={intl.formatMessage({ id: 'quickLink.courseStats' })} />
      <Box mt={2}>
        <CourseStatsTable
          loading={loading}
          subjects={stats?.subjects}
          error={error}
          onRefetchStats={onRefetchStats}
          onSelectSubject={handleSelectSubject}
        />
      </Box>
    </>
  );
};

export default CourseStatsPage;

// const handleSelectSubject = useCallback(
//   (data) => {
//     history.push(`stats/subjects/${data._id}`);
//   },
//   [history]
// );
